export const NATIONALITY = [
  { "label": "Afghan", "value": "Afghan" },
  { "label": "Albanian", "value": "Albanian" },
  { "label": "Algerian", "value": "Algerian" },
  { "label": "American", "value": "American" },
  { "label": "Andorran", "value": "Andorran" },
  { "label": "Angolan", "value": "Angolan" },
  { "label": "Anguillan", "value": "Anguillan" },
  { "label": "Argentine", "value": "Argentine" },
  { "label": "Armenian", "value": "Armenian" },
  { "label": "Australian", "value": "Australian" },
  { "label": "Austrian", "value": "Austrian" },
  { "label": "Azerbaijani", "value": "Azerbaijani" },
  { "label": "Bahamian", "value": "Bahamian" },
  { "label": "Bahraini", "value": "Bahraini" },
  { "label": "Bangladeshi", "value": "Bangladeshi" },
  { "label": "Barbadian", "value": "Barbadian" },
  { "label": "Belarusian", "value": "Belarusian" },
  { "label": "Belgian", "value": "Belgian" },
  { "label": "Belizean", "value": "Belizean" },
  { "label": "Beninese", "value": "Beninese" },
  { "label": "Bermudian", "value": "Bermudian" },
  { "label": "Bhutanese", "value": "Bhutanese" },
  { "label": "Bolivian", "value": "Bolivian" },
  { "label": "Botswanan", "value": "Botswanan" },
  { "label": "Brazilian", "value": "Brazilian" },
  { "label": "British", "value": "British" },
  { "label": "British Virgin Islander", "value": "British Virgin Islander" },
  { "label": "Bruneian", "value": "Bruneian" },
  { "label": "Bulgarian", "value": "Bulgarian" },
  { "label": "Burkinan", "value": "Burkinan" },
  { "label": "Burmese", "value": "Burmese" },
  { "label": "Burundian", "value": "Burundian" },
  { "label": "Cambodian", "value": "Cambodian" },
  { "label": "Cameroonian", "value": "Cameroonian" },
  { "label": "Canadian", "value": "Canadian" },
  { "label": "Cape Verdean", "value": "Cape Verdean" },
  { "label": "Cayman Islander", "value": "Cayman Islander" },
  { "label": "Central African", "value": "Central African" },
  { "label": "Chadian", "value": "Chadian" },
  { "label": "Chilean", "value": "Chilean" },
  { "label": "Chinese", "value": "Chinese" },
  { "label": "Citizen of Antigua and Barbuda", "value": "Citizen of Antigua and Barbuda" },
  { "label": "Citizen of Bosnia and Herzegovina", "value": "Citizen of Bosnia and Herzegovina" },
  { "label": "Citizen of Guinea-Bissau", "value": "Citizen of Guinea-Bissau" },
  { "label": "Citizen of Kiribati", "value": "Citizen of Kiribati" },
  { "label": "Citizen of Seychelles", "value": "Citizen of Seychelles" },
  { "label": "Citizen of the Dominican Republic", "value": "Citizen of the Dominican Republic" },
  { "label": "Citizen of Vanuatu", "value": "Citizen of Vanuatu" },
  { "label": "Colombian", "value": "Colombian" },
  { "label": "Comoran", "value": "Comoran" },
  { "label": "Congolese (Congo)", "value": "Congolese (Congo)" },
  { "label": "Congolese (DRC)", "value": "Congolese (DRC)" },
  { "label": "Cook Islander", "value": "Cook Islander" },
  { "label": "Costa Rican", "value": "Costa Rican" },
  { "label": "Croatian", "value": "Croatian" },
  { "label": "Cuban", "value": "Cuban" },
  { "label": "Cymraes", "value": "Cymraes" },
  { "label": "Cymro", "value": "Cymro" },
  { "label": "Cypriot", "value": "Cypriot" },
  { "label": "Czech", "value": "Czech" },
  { "label": "Danish", "value": "Danish" },
  { "label": "Djiboutian", "value": "Djiboutian" },
  { "label": "Dominican", "value": "Dominican" },
  { "label": "Dutch", "value": "Dutch" },
  { "label": "East Timorese", "value": "East Timorese" },
  { "label": "Ecuadorean", "value": "Ecuadorean" },
  { "label": "Egyptian", "value": "Egyptian" },
  { "label": "Emirati", "value": "Emirati" },
  { "label": "English", "value": "English" },
  { "label": "Equatorial Guinean", "value": "Equatorial Guinean" },
  { "label": "Eritrean", "value": "Eritrean" },
  { "label": "Estonian", "value": "Estonian" },
  { "label": "Ethiopian", "value": "Ethiopian" },
  { "label": "Faroese", "value": "Faroese" },
  { "label": "Fijian", "value": "Fijian" },
  { "label": "Filipino", "value": "Filipino" },
  { "label": "Finnish", "value": "Finnish" },
  { "label": "French", "value": "French" },
  { "label": "Gabonese", "value": "Gabonese" },
  { "label": "Gambian", "value": "Gambian" },
  { "label": "Georgian", "value": "Georgian" },
  { "label": "German", "value": "German" },
  { "label": "Ghanaian", "value": "Ghanaian" },
  { "label": "Gibraltarian", "value": "Gibraltarian" },
  { "label": "Greek", "value": "Greek" },
  { "label": "Greenlandic", "value": "Greenlandic" },
  { "label": "Grenadian", "value": "Grenadian" },
  { "label": "Guamanian", "value": "Guamanian" },
  { "label": "Guatemalan", "value": "Guatemalan" },
  { "label": "Guinean", "value": "Guinean" },
  { "label": "Guyanese", "value": "Guyanese" },
  { "label": "Haitian", "value": "Haitian" },
  { "label": "Honduran", "value": "Honduran" },
  { "label": "Hong Konger", "value": "Hong Konger" },
  { "label": "Hungarian", "value": "Hungarian" },
  { "label": "Icelandic", "value": "Icelandic" },
  { "label": "Indian", "value": "Indian" },
  { "label": "Indonesian", "value": "Indonesian" },
  { "label": "Iranian", "value": "Iranian" },
  { "label": "Iraqi", "value": "Iraqi" },
  { "label": "Irish", "value": "Irish" },
  { "label": "Israeli", "value": "Israeli" },
  { "label": "Italian", "value": "Italian" },
  { "label": "Ivorian", "value": "Ivorian" },
  { "label": "Jamaican", "value": "Jamaican" },
  { "label": "Japanese", "value": "Japanese" },
  { "label": "Jordanian", "value": "Jordanian" },
  { "label": "Kazakh", "value": "Kazakh" },
  { "label": "Kenyan", "value": "Kenyan" },
  { "label": "Kittitian", "value": "Kittitian" },
  { "label": "Kosovan", "value": "Kosovan" },
  { "label": "Kuwaiti", "value": "Kuwaiti" },
  { "label": "Kyrgyz", "value": "Kyrgyz" },
  { "label": "Lao", "value": "Lao" },
  { "label": "Latvian", "value": "Latvian" },
  { "label": "Lebanese", "value": "Lebanese" },
  { "label": "Liberian", "value": "Liberian" },
  { "label": "Libyan", "value": "Libyan" },
  { "label": "Liechtenstein citizen", "value": "Liechtenstein citizen" },
  { "label": "Lithuanian", "value": "Lithuanian" },
  { "label": "Luxembourger", "value": "Luxembourger" },
  { "label": "Macanese", "value": "Macanese" },
  { "label": "Macedonian", "value": "Macedonian" },
  { "label": "Malagasy", "value": "Malagasy" },
  { "label": "Malawian", "value": "Malawian" },
  { "label": "Malaysian", "value": "Malaysian" },
  { "label": "Maldivian", "value": "Maldivian" },
  { "label": "Malian", "value": "Malian" },
  { "label": "Maltese", "value": "Maltese" },
  { "label": "Marshallese", "value": "Marshallese" },
  { "label": "Martiniquais", "value": "Martiniquais" },
  { "label": "Mauritanian", "value": "Mauritanian" },
  { "label": "Mauritian", "value": "Mauritian" },
  { "label": "Mexican", "value": "Mexican" },
  { "label": "Micronesian", "value": "Micronesian" },
  { "label": "Moldovan", "value": "Moldovan" },
  { "label": "Monegasque", "value": "Monegasque" },
  { "label": "Mongolian", "value": "Mongolian" },
  { "label": "Montenegrin", "value": "Montenegrin" },
  { "label": "Montserratian", "value": "Montserratian" },
  { "label": "Moroccan", "value": "Moroccan" },
  { "label": "Mosotho", "value": "Mosotho" },
  { "label": "Mozambican", "value": "Mozambican" },
  { "label": "Namibian", "value": "Namibian" },
  { "label": "Nauruan", "value": "Nauruan" },
  { "label": "Nepalese", "value": "Nepalese" },
  { "label": "New Zealander", "value": "New Zealander" },
  { "label": "Nicaraguan", "value": "Nicaraguan" },
  { "label": "Nigerian", "value": "Nigerian" },
  { "label": "Nigerien", "value": "Nigerien" },
  { "label": "Niuean", "value": "Niuean" },
  { "label": "North Korean", "value": "North Korean" },
  { "label": "Northern Irish", "value": "Northern Irish" },
  { "label": "Norwegian", "value": "Norwegian" },
  { "label": "Omani", "value": "Omani" },
  { "label": "Pakistani", "value": "Pakistani" },
  { "label": "Palauan", "value": "Palauan" },
  { "label": "Palestinian", "value": "Palestinian" },
  { "label": "Panamanian", "value": "Panamanian" },
  { "label": "Papua New Guinean", "value": "Papua New Guinean" },
  { "label": "Paraguayan", "value": "Paraguayan" },
  { "label": "Peruvian", "value": "Peruvian" },
  { "label": "Pitcairn Islander", "value": "Pitcairn Islander" },
  { "label": "Polish", "value": "Polish" },
  { "label": "Portuguese", "value": "Portuguese" },
  { "label": "Prydeinig", "value": "Prydeinig" },
  { "label": "Puerto Rican", "value": "Puerto Rican" },
  { "label": "Qatari", "value": "Qatari" },
  { "label": "Romanian", "value": "Romanian" },
  { "label": "Russian", "value": "Russian" },
  { "label": "Rwandan", "value": "Rwandan" },
  { "label": "Salvadorean", "value": "Salvadorean" },
  { "label": "Sammarinese", "value": "Sammarinese" },
  { "label": "Samoan", "value": "Samoan" },
  { "label": "Sao Tomean", "value": "Sao Tomean" },
  { "label": "Saudi Arabian", "value": "Saudi Arabian" },
  { "label": "Scottish", "value": "Scottish" },
  { "label": "Senegalese", "value": "Senegalese" },
  { "label": "Serbian", "value": "Serbian" },
  { "label": "Sierra Leonean", "value": "Sierra Leonean" },
  { "label": "Singaporean", "value": "Singaporean" },
  { "label": "Slovak", "value": "Slovak" },
  { "label": "Slovenian", "value": "Slovenian" },
  { "label": "Solomon Islander", "value": "Solomon Islander" },
  { "label": "Somali", "value": "Somali" },
  { "label": "South African", "value": "South African" },
  { "label": "South Korean", "value": "South Korean" },
  { "label": "South Sudanese", "value": "South Sudanese" },
  { "label": "Spanish", "value": "Spanish" },
  { "label": "Sri Lankan", "value": "Sri Lankan" },
  { "label": "St Helenian", "value": "St Helenian" },
  { "label": "St Lucian", "value": "St Lucian" },
  { "label": "Stateless", "value": "Stateless" },
  { "label": "Sudanese", "value": "Sudanese" },
  { "label": "Surinamese", "value": "Surinamese" },
  { "label": "Swazi", "value": "Swazi" },
  { "label": "Swedish", "value": "Swedish" },
  { "label": "Swiss", "value": "Swiss" },
  { "label": "Syrian", "value": "Syrian" },
  { "label": "Taiwanese", "value": "Taiwanese" },
  { "label": "Tajik", "value": "Tajik" },
  { "label": "Tanzanian", "value": "Tanzanian" },
  { "label": "Thai", "value": "Thai" },
  { "label": "Togolese", "value": "Togolese" },
  { "label": "Tongan", "value": "Tongan" },
  { "label": "Trinidadian", "value": "Trinidadian" },
  { "label": "Tristanian", "value": "Tristanian" },
  { "label": "Tunisian", "value": "Tunisian" },
  { "label": "Turkish", "value": "Turkish" },
  { "label": "Turkmen", "value": "Turkmen" },
  { "label": "Turks and Caicos Islander", "value": "Turks and Caicos Islander" },
  { "label": "Tuvaluan", "value": "Tuvaluan" },
  { "label": "Ugandan", "value": "Ugandan" },
  { "label": "Ukrainian", "value": "Ukrainian" },
  { "label": "Uruguayan", "value": "Uruguayan" },
  { "label": "Uzbek", "value": "Uzbek" },
  { "label": "Vatican citizen", "value": "Vatican citizen" },
  { "label": "Venezuelan", "value": "Venezuelan" },
  { "label": "Vietnamese", "value": "Vietnamese" },
  { "label": "Vincentian", "value": "Vincentian" },
  { "label": "Wallisian", "value": "Wallisian" },
  { "label": "Welsh", "value": "Welsh" },
  { "label": "Yemeni", "value": "Yemeni" },
  { "label": "Zambian", "value": "Zambian" },
  { "label": "Zimbabwean", "value": "Zimbabwean" }
]
